import { BaseControl } from '.';

// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// MonthYearControl — single month picker. Used by PersonasPresenceWidget
// (the dashboard's presence card picks one month at a time).
//
// Value shape: 'YYYY-MM' string, or null when unset.

/**
 * @extends {BaseControl<string|null>}
 */
export class MonthYearControl extends BaseControl {
    /** @type {BaseControl<string|null>['render']} */
    render(value, onChange) {
        return (
            <MonthYearControlRenderer
                value={value}
                onChange={onChange}
                label={this.label}
                description={this.description}
            />
        )
    }
}

/**
 * @param {object} props
 * @param {string|null} props.value - 'YYYY-MM' or null
 * @param {(value: string|null) => void} props.onChange - Fires with the new month string or null when cleared
 * @param {string} [props.label] - Optional label rendered above the input
 * @param {string} [props.description] - Optional description rendered below the input
 */
const MonthYearControlRenderer = ({ value, onChange, label, description }) => {
    return (
        <div className="month-year-control">
            {label && <span className="month-year-control-label">{label}</span>}
            <input
                type="month"
                value={value || ''}
                onChange={(e) => onChange(e.target.value || null)}
            />
            {description && <p className="month-year-control-description">{description}</p>}
        </div>
    )
}
